// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wUCbgkuVXkd5I- {\n  background: var(--ds-background-input, #FFFFFF);\n  border: 1px solid var(--ds-border-input, #DFE1E6);\n  border-radius: 3px;\n  padding: 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "wUCbgkuVXkd5I-"
};
export default ___CSS_LOADER_EXPORT___;
